import { ApiService } from "@/api";

export const updateGroup = (
  groupId: string,
  info: {
    name?: string;
    description?: string;
  }
) => {
  return ApiService.baseAction(
    "group/update/" + groupId,
    {
      data: info,
    },
    "post"
  );
};
